import Immutable from 'immutable';
import createReducer from 'common/redux/utils/createReducer';
import { RECEIVE_FUNNEL } from 'funnel/actions/funnel';
import { DELETE_QUESTION } from 'funnel/actions/question';
import { DELETE_ANSWER } from 'funnel/actions/answer';
import { DELETE_ADVICE } from 'funnel/actions/advice';

const initialState = {
  questions: Immutable.List(),
  answers: Immutable.List(),
  advices: Immutable.List(),
};

const history = createReducer(initialState, {
  [DELETE_QUESTION](state, { question }) {
    if (question.new) {
      return state;
    }

    return {
      ...state,
      questions: state.questions.push(question.id),
    };
  },
  [DELETE_ANSWER](state, { answer }) {
    if (answer.new) {
      return state;
    }

    return {
      ...state,
      answers: state.answers.push(answer.id),
    };
  },
  [DELETE_ADVICE](state, { advice }) {
    if (advice.new) {
      return state;
    }

    return {
      ...state,
      advices: state.advices.push(advice.id),
    };
  },
  [RECEIVE_FUNNEL](state) {
    return initialState;
  },
});

export default history;



// WEBPACK FOOTER //
// ./src/modules/funnel/reducers/history.js